import * as React from 'react';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';
import CONFIG, { window2config } from './cfg/config';
import { connect } from 'react-redux';
import { AppState, Actions, store, IPageState } from './appredux';


import { io } from "socket.io-client";
//import { DisplayState } from './App';

//const SOCKET_LINK = "ws://localhost:5001"
const SOCKET_LINK = "ws://192.168.0.101:5001"
//const SOCKET_LINK = "ws://" + CONFIG.ipSerwer + ":5001"



interface SocketProps {
  page: IPageState,
  //setPanel: (n: DisplayState) => void
}
interface SocketState {
}

class Socket extends React.Component<SocketProps & WithTranslation & TransProps & WithStyles<typeof styles>, SocketState> {

  constructor(props: SocketProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
    }

    const socket = io(SOCKET_LINK); 

//   const socket = io(SOCKET_LINK,{
//     transports: ['websocket']
//   }
// ); 

    //v2
    // const socket = io(SOCKET_LINK, {
    //   transports: ["websocket"]
    // }); 

    //odebranie danych z serwera, nazwa połączenia "send_message" 
    socket.on("send_message", (arg) => {
      console.log(arg)
      
      //let data = JSON.parse(arg)

      if (arg.data_message) {
        let tresc = arg.data_message
        if (tresc.split("|").length === 2) {
          let typ = tresc.split("|")[0]
          let opis = tresc.split("|")[1]
          //store.dispatch(Actions.pageState.setPowiadomienia({ typ: typ, opis: opis }));
          console.log(tresc)

          if (typ === "3") {
            //this.setState({ panel: DisplayState.powiadomienia })
            //this.props.setPanel(DisplayState.powiadomienia)
            //let audio = new Audio(sound);
            let audio = new Audio("https://vsc24.net/vscBramki/bramki/mp3/sound.mp3");
            audio.play();
          }

        }
      }

    });

    // //wysłanie danych na serwer co 3 sekundy
    // setInterval(() => {
    //   let dane = {"message":"TEST z aplikacji"}
    //   let json_dane =  JSON.stringify(dane);
    //   socket.emit("aplikacja_dane", json_dane)
    //   console.log("wyslanie socketa")
    // }, 3000);

    socket.on('disconnect', () => {
      console.log('user disconnected');
    });

    socket.on("connect_error", (err) => {
      console.log(`connect_error due to ${err}`);
      console.log(err);
    });

  }

  componentDidMount() {
  }



  
  render() {
    const { classes, t } = this.props;

    return (
     <>
      </>
    );
  }
}

const styles = (theme: Theme) => ({ 
 
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Socket))); 

